const menusService = [
    {
        "title": "weekly report",
        "url": "weekly",
        "default": "",
        "input": true,
        "subMenus": [],
        "external_users_access": false,
    },
    {
        "title": "monthly report",
        "url": "monthly",
        "default": "/summary",
        "external_users_access": false,
        "subMenus": [
            {
                "title": "summary",
                "url": "summary"
            },
            {
                "title": "yearly actuals vs budget",
                "url": "ya_vs_budget",
                "input": true
            },
            {
                "title": "yearly actuals vs prior year",
                "url": "ya_vs_py"
            },
            {
                "title": "Last 12 Months",
                "url": "last_12_months"
            },
            {
                "title": "quarterly actuals",
                "url": "quarterly"
            }
        ]
    },
    {
        "title": "individual sales rep performance",
        "url": "employees",
        "default": "/activity",
        "external_users_access": false,
        "subMenus": [
            {
                "title": "employee activity",
                "url": "activity"
            },
            {
                "title": "employee attainment",
                "url": "attainment"
            },
            {
                "title": "employee performance",
                "url": "performance",
                "input": true
            },
            {
                "title": "employee quota",
                "url": "quota",
                "input": true
            },
            {
                "title": "quarterly attainment",
                "url": "quarterly"
            },
            {
                "title": "rolling gross pipeline",
                "url": "pipeline",
                "input": true
            },
            {
                "title": "pipeline to quota ratio",
                "url": "ptqr",
            },
        ]
    },
    {
        "title": "SDR",
        "url": "sdr",
        "default": "",
        "input": true,
        "subMenus": [],
        "external_users_access": false,
    },
    {
        "title": "talent",
        "url": "hr",
        "default": "/staffing-dashboard",
        "external_users_access": false,
        "subMenus": [
            {
                "title": "Staffing Dashboard",
                "url": "staffing-dashboard"
            },
            {
                "title": "Staffing Aggregate",
                "url": "staffing-agregate"
            },
            {
                "title": "open positions",
                "url": "staff"
            },
            {
                "title": "candidates",
                "url": "candidates"
            },
            {
                "title": "census",
                "url": "census"
            },
            {
                "title": "staffing budget",
                "url": "plans"
            }
        ]
    },
    {
        title: 'Talent Tracking',
        url: 'talent_tracking',
        default: '',
        input: true,
        subMenus: [],
        "external_users_access": true,
    },
];

export default menusService;
